// src/pages/choose/ChooseAction.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { BookOpenIcon, UserGroupIcon, InboxIcon } from "@heroicons/react/24/solid";

export default function ChooseAction({ selectedStore }) {
    const navigate = useNavigate();

    const cards = [
        {
            key: "books",
            Icon: BookOpenIcon,
            title: "Manage Books",
            bullets: ["Check book History", "Add Damage", "Check book Information"],
            onClick: () => navigate("/dashboard"),
        },
        {
            key: "members",
            Icon: UserGroupIcon,
            title: "Manage Member",
            bullets: ["Returning and Issuing Books", "Walk In Virtual Order", "Manage Subscription"],
            onClick: () => navigate("/members"),
        },
        {
            key: "orders",
            Icon: InboxIcon,
            title: "Order Fulfillment",
            bullets: ["View Order", "Manage Order", "Cancel Order"],
            onClick: () => navigate("/orders"),
        },
    ];

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10">
                {/* store header */}
                <div className="mb-8">
                    {selectedStore ? (
                        <div className="text-left">
                            <div className="text-gray-500 text-sm">Store name</div>
                            <div className="text-gray-700 font-semibold">{selectedStore.name}</div>
                            <div className="text-sm text-gray-400">{selectedStore.location}, {selectedStore.id}, {selectedStore.status}</div>
                        </div>
                    ) : (
                        <div className="text-left text-gray-400">No store selected</div>
                    )}
                </div>

                {/* title */}
                <h1 className="text-center text-4xl md:text-5xl font-semibold mb-10">Choose a Action</h1>

                {/* cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {cards.map((c) => (
                        <div key={c.key} className="border rounded-xl p-8 flex flex-col justify-between shadow-sm" style={{ minHeight: 360 }}>
                            <div>
                                {/* big icon */}
                                <div className="flex items-center justify-center mb-6">
                                    <div className="w-28 h-28 rounded-md bg-black flex items-center justify-center">
                                        <c.Icon className="w-14 h-14 text-white" />
                                    </div>
                                </div>

                                <h3 className="text-2xl font-semibold text-center mb-4">{c.title}</h3>

                                <ul className="text-gray-600 text-sm list-disc list-inside space-y-2 max-w-xs mx-auto">
                                    {c.bullets.map((b, i) => (
                                        <li key={i}>{b}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="mt-6">
                                <button
                                    onClick={c.onClick}
                                    className="mx-auto block w-full md:w-40 bg-black text-white py-3 rounded-md hover:bg-gray-800 transition-colors"
                                >
                                    Open
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}
